// helpers/meta/loadMetaPixel.ts

import { FbqFn } from "@/types";
import { getConsentState } from "@/helpers/tracking/consent";

/**
 * Lädt den Facebook/Meta Pixel, falls noch nicht aktiv.
 * Unterstützt Multi-Pixel-Konfiguration (/anmelden, /bewerben etc.)
 * und garantiert, dass jeder Pixel nur einmal initialisiert wird.
 */

export function loadMetaPixel(pixelId: string): void {
    // Harte Sperre: ohne Marketing-Einwilligung wird nichts geladen (§ 25 TDDDG).
    // Wichtig, weil loadMetaPixel auch außerhalb des Consent-Bindings (router.beforeEach) aufgerufen wird.
    if (!getConsentState().marketing) return;

    const w = window as Window & {
        fbq?: FbqFn;
        _fbq?: FbqFn;
        _loadedPixels?: Record<string, boolean>;
        _metaScriptAppended?: boolean;
    };

    if (!w._loadedPixels) w._loadedPixels = {};

    // Falls Pixel schon geladen → KEIN weiteres init
    if (w._loadedPixels[pixelId]) return;

    // fbq Stub erzeugen, falls noch nicht vorhanden
    if (!w.fbq) {
        const fbqStub: FbqFn = (function () {
            const fn = function (...args: unknown[]) {
                if ((fn as FbqFn).callMethod)
                    (fn as FbqFn).callMethod?.(...args);
                else ((fn as FbqFn).queue as unknown[]).push(args);
            } as unknown as FbqFn;
            fn.loaded = false;
            fn.queue = [];
            return fn;
        })();

        w.fbq = fbqStub;
        w._fbq = fbqStub;
    }

    // Script nur einmal anhängen
    if (!w._metaScriptAppended) {
        const s = document.createElement("script");
        s.async = true;
        s.src = "https://connect.facebook.net/en_US/fbevents.js";
        const first = document.getElementsByTagName("script")[0];
        first?.parentNode?.insertBefore(s, first);
        w._metaScriptAppended = true;
    }

    // Nur initialisieren, kein PageView senden!
    try {
        w.fbq?.("set", "autoConfig", false, pixelId);
        w.fbq?.("init", pixelId);
        w._loadedPixels[pixelId] = true;
    } catch (err) {
        // do nothing
    }
}
